import axios from 'axios';
import { API_URL } from '../config';
import { TimeSlotType, Break } from '../types';
import { AxiosRequestConfig } from 'axios';

interface CustomAxiosRequestConfig extends AxiosRequestConfig {
  permission?: string;
}

// COMPANY DAILY & WEEKLY WORKING HOURS

// WORKING-HOURS (DAILY)
export const getWorkingHours = async (token: string) => {
  const response = await axios.get(`${API_URL}/presenze/company/working-hours/`,
    {
      headers: {
        'Authorization': `${token}`,
      },
    });
    return response.data;
};

export const deleteWorkingHours = async (token: string, id: number) => {
  const response = await axios.delete(`${API_URL}/presenze/company/working-hours/${id}/`, {
    headers: {
      'Authorization': token
    }
  });
  return response.data;
};

//WEEKLY WORKING-HOURS 
export const deleteWeeklyWorkingHours = async (token: string, id: number) => {
  const response = await axios.delete(`${API_URL}/presenze/company/weekly-working-hours/${id}/`, {
    headers: {
      'Authorization': token
    }
  });
  return response.data;
};

export const addWeeklyWorkingHourSlot = async (token: string, data: any) => {
  const response = await axios.post( `${API_URL}/presenze/company/weekly-working-hours-slot/`,
  data,
    {
      headers: {
        'Authorization': `${token}` 
      }
    }
  );
  return response.data;
};

export const getCompanyWeeklyWorkingHours = async (token: string) => {
  const response = await axios.get(`${API_URL}/presenze/company/weekly-working-hours/`,
    {
      headers: {
        'Authorization': `${token}`,
      },
    });
    return response.data;
};

export const patchUpdateWeeklyWorkingHourSlot = async (token: string, id: number, data: any) => {
  const response = await axios.patch(`${API_URL}/presenze/company/weekly-working-hours-slot/${id}/`,
  data,
  {
    headers: {
      'Authorization': `${token}`,
    },
  });
    return response.data;
};

export const deleteWeeklyWorkingHoursSlot = async (token: string, id: number) => {
  const response = await axios.delete(`${API_URL}/presenze/company/weekly-working-hours-slot/${id}/`, {
    headers: {
      'Authorization': token
    }
  });
  return response.data;
};


//WORKING HOURS ID COMPANY
export const getWorkingHoursById = async (token: string, id: number) => {
  const response = await axios.get(`${API_URL}/presenze/company/working-hours/${id}/`,
    {
      headers: {
        'Authorization': `${token}`,
      },
    });
    return response.data;
};

// COMPANY WORKING HOURS
export const getWorkingHoursCompany = async (token: string, id: number) => {
  const response = await axios.get(`${API_URL}/presenze/company/working-hours/${id}/`,
    {
      headers: {
        'Authorization': `${token}`,
      },
    });
    return response.data;
};

export const updateWorkingHoursCompany = async (token: string, id: number, whName: string) => {
  const response = await axios.put(`${API_URL}/presenze/company/working-hours/${id}/`, {name: whName},
    {
      headers: {
        'Authorization': `${token}`,
      },
    });
    return response.data;
};

// COMPANY WEEKLY WORKING HOURS
export const updateWeeklyWorkingHoursCompany = async (token: string, id: number, wwhName: string) => {
  const response = await axios.patch(`${API_URL}/presenze/company/weekly-working-hours/${id}/`, {name: wwhName},
    {
      headers: {
        'Authorization': `${token}`,
      },
    });
    return response.data;
};


//CREATE TIMESLOT COMPOUND
export const createTimeSlotCompanyCompound = async (token: string, data: any, contentType: string, objectId: number) => {
  const response = await axios.post( `${API_URL}/presenze/company/time-slots/compound/`,
    {...data, content_type: contentType, object_id: objectId},
    {
      headers: {
        'Authorization': `${token}` 
      }
    }
  );
  return response.data;
};


// TIME SLOT
export const getTimeSlotCompany = async (token: string, id: number) => {
  const response = await axios.get(`${API_URL}/presenze/company/time-slots/${id}/`,
    {
      headers: {
        'Authorization': `${token}`,
      },
    });
    return response.data;
};

export const deleteTimeSlotCompany = async (token: string, id: number) => {
  const response = await axios.delete(`${API_URL}/presenze/company/time-slots/${id}/`, {
    headers: {
      'Authorization': token
    }
  });
  return response.data;
};

export const updateTimeSlot = async (token: string, id: number, timeSlot: TimeSlotType,) => {
  const response = await axios.patch(`${API_URL}/presenze/company/time-slots/${id}/`, {...timeSlot}, 
  {
    headers: {
      'Authorization': `${token}`,
    },
  });
  return response.data;
};

// BREAKS
export const getBreakTimeSlot = async (token: string, id: number) => {
  const response = await axios.get(`${API_URL}/presenze/company/breaks/${id}/`,
    {
      headers: {
        'Authorization': `${token}`,
      },
    });
    return response.data;
};

export const createBreakTimeSlot = async (token: string, data: any, timeSlotId: number) => {
  const response = await axios.post( `${API_URL}/presenze/company/breaks/`,
    {...data,  time_slot: timeSlotId},
    {
      headers: {
        'Authorization': `${token}` 
      }
    }
  );
  return response.data;
};


export const updateBreakTimeSlot = async (token: string, id: number, breakData: Break, timeSlotId: number) => {
  const response = await axios.put(`${API_URL}/presenze/company/breaks/${id}/`, {...breakData, time_slot: timeSlotId}, 
  {
    headers: {
      'Authorization': `${token}`,
    },
  });
  return response.data;
};

export const deleteBreakTimeSlot = async (token: string, id: number) => {
  const response = await axios.delete(`${API_URL}/presenze/company/breaks/${id}/`, {
    headers: {
      'Authorization': token
    }
  });
  return response.data;
};


// WORKING-HOURS COMPOUND
export const getWorkingHoursCompound = async (
  token: string,
  ouId: number | 'all' | null = null,
  permission: string | null = null,
  page: number | null = null,
  pageSize: number | null = 25,
  search = "",
  pagination = false,
  signal?: AbortSignal
) => {
  const params: Record<string, string | number | boolean> = {};

  if (ouId) params['ou'] = ouId;
  if (permission) params['permission'] = permission;

  if (pagination) params['pagination'] = true;
  if (pagination && page != null) params['page'] = page;
  if (pagination && pageSize != null) params['page_size'] = pageSize;

  if (search && search.trim()) params['search'] = search.trim();

  const response = await axios.get(`${API_URL}/presenze/company/working-hours/compound/`, {
    headers: {
      'Authorization': `${token}`,
    },
    params,
    signal,
    permission,
  } as CustomAxiosRequestConfig);
  return response.data;
};

export const createWorkingHoursCompound = async (token: string, data: any) => {
  const response = await axios.post( `${API_URL}/presenze/company/working-hours/compound/`,
    data,
    {
      headers: {
        'Authorization': `${token}` 
      }
    }
  );
  return response.data;
};


//WEEKLY WORKING-HOUR COMPOUND
export const createWeeklyWorkingHourCompound = async (token: string, data: any) => {
  data.slots_by_weekday = data.slots_by_weekday.map((wwhs: any) => {
    if(wwhs.working_hour) {
      wwhs.working_hour_id = wwhs.working_hour
      delete wwhs.working_hour;
    }
    return wwhs;
  });
  const response = await axios.post( `${API_URL}/presenze/company/weekly-working-hours/compound/`,
    data,
    {
      headers: {
        'Authorization': `${token}` 
      }
    }
  );
  return response.data;
};

export const getWeeklyWorkingHourCompound = async (
  token: string,
  ouId: number | 'all' | null = null,
  employeeId?: number | null,
  permission?: string | null,
  page: number | null = null,
  pageSize: number | null = 25,
  search = "",
  pagination = false,
  signal?: AbortSignal,
) => {
  const params: Record<string, string | number | boolean> = {};

  if (ouId) params['ou'] = ouId;
  if (employeeId) params['employee'] = employeeId;
  if (permission) params['permission'] = permission;

  if (pagination) params['pagination'] = true;
  if (pagination && page != null) params['page'] = page;
  if (pagination && pageSize != null) params['page_size'] = pageSize;

  if (search && search.trim()) params['search'] = search.trim();

  const response = await axios.get(`${API_URL}/presenze/company/weekly-working-hours/compound/`, {
    headers: {
      'Authorization': `${token}`,
    },
    params,
    signal,
    permission,
  } as CustomAxiosRequestConfig);
  return response.data;
};

export const getWeeklyWorkingHoursCompoundById = async (token: string, id: number) => {
  const response = await axios.get(`${API_URL}/presenze/company/weekly-working-hours/compound/${id}/`,
    {
      headers: {
        'Authorization': `${token}`,
      },
    });
    return response.data;
};

// EMPLOYEE WEEKLY WORKING HOURS
export const createEmployeeWeeklyWorkingHour = async (token: string, employeeId: number, data: any) => {
    const response = await axios.post(`${API_URL}/presenze/employee/${employeeId}/weekly-working-hour/`,
      data, 
      {
        headers: {
            'Authorization': token
        }
    });
  return response.data;
};

export const getEmployeeWeeklyWorkingHour = async (token: string, employeeId: number, permission: string | null, signal = null) => {
  const config: any = {};

  if (permission) config.permission = permission;
  if (signal) config.signal = signal;

  const response = await axios.get(`${API_URL}/presenze/employee/${employeeId}/weekly-working-hour/`, 
  {
    headers: {
      'Authorization': token
    },
    ...config
  } as CustomAxiosRequestConfig);
  return response.data;
};


export const updateEmployeeWeeklyWorkingHour = async (token: string, employeeId: number, data: {weekly_working_hour: number}) => {
  const response = await axios.patch(`${API_URL}/presenze/employee/${employeeId}/weekly-working-hour/`,
  data,
    {
      headers: {
          'Authorization': token
      }
    });
  return response.data;
};

export const deleteEmployeeWeeklyWorkingHour = async (token: string, employeeId: number) => {
  const response = await axios.delete(`${API_URL}/presenze/employee/${employeeId}/weekly-working-hour/`, {
    headers: {
      'Authorization': token
    }
  });
  return response.data;
};
